import Card from "components/Card/Card";
import { ControlledInput } from "components/Card/ControlledInput";
import { TextInput } from "components/inputs";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes, TinType } from "types/DataTypes";

type RRETinForeignAddressSectionProps = {
  control: Control<TinType>;
  getValues: UseFormGetValues<TinType>;
  setValue: UseFormSetValue<TinType>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const RRETinForeignAddressSection = ({
  control,
  handleFieldChange,
}: RRETinForeignAddressSectionProps) => {
  return (
    <Card heading="Foreign RRE Address">
      <ControlledInput
        control={control}
        name="foreign_rre_address_line1"
        label="Address Line 1"
        placeholder="Enter Address Line 1"
        errors={{}}
        maxLength={32}
        onSave={(value) =>
          handleFieldChange("foreign_rre_address_line1", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="foreign_rre_address_line2"
        label="Address Line 2"
        placeholder="Enter Address Line 2"
        errors={{}}
        maxLength={32}
        onSave={(value) =>
          handleFieldChange("foreign_rre_address_line2", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="foreign_rre_address_line3"
        label="Address Line 3"
        placeholder="Enter Address Line 3"
        errors={{}}
        maxLength={32}
        onSave={(value) =>
          handleFieldChange("foreign_rre_address_line3", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="foreign_rre_address_line4"
        label="Address Line 4"
        placeholder="Enter Address Line 4"
        errors={{}}
        maxLength={32}
        onSave={(value) =>
          handleFieldChange("foreign_rre_address_line4", value)
        }
        componentType={TextInput}
      />
    </Card>
  );
};

export default RRETinForeignAddressSection;
